// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-Badge-Badge-module__container--XldgG","summaryTable":"src-components-Badge-Badge-module__summaryTable--185rl"};